import moment from "moment";

export const amountFormat = (value, extraZeros) => {
  const zeros = extraZeros ? extraZeros : 2;
  // ₦
  const val = value ?? 0;
  return ` NGN${val?.toLocaleString(undefined, {
    minimumFractionDigits: zeros,
    maximumFractionDigits: zeros,
  })}`;
};

export const formatNumber = (value, extraZeros) => {
  const zeros = extraZeros ? extraZeros : 2;
  const val = value ?? 0;

  return val?.toLocaleString(undefined, {
    minimumFractionDigits: zeros,
    maximumFractionDigits: zeros,
  });
};

export const formatDate = (date) => {
  return date ? moment(date).format("ll h:mma") : "N/A";
};

export const cardFormatDate = (date) => {
  return moment(date).format("MM/YY");
};

export const formatDateNo = (data) => {
  return moment(data).format("ll");
};

export const lowerCase = (text) => {
  return text.toLowerCase();
};
